<template>
  <div class="loading">
    <img :src="loadImg" alt="" />
    <p>数据加载中...</p>
  </div>
</template>
<script>
import loadImg from "@/assets/images/video/loading-video.png";

export default {
  name: "loadingVideo",
  data() {
    return {
      loadImg
    };
  }
};
</script>
<style scoped>
@keyframes load {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.loading {
  width: 120px;
  height: 60px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -35%);
  text-align: center;
}
img {
  animation: load 1s linear infinite;
}
p {
  color: rgba(70, 191, 234, 0.5);
  margin-top: 14px;
  font-size: 14px;
}
</style>
